<template>
  <v-layout align-center column>
    <p
      class="Hero-Text"
    
    >
      Syarat & Ketentuan
    </p>

    <img
      src="../../assets/SyaratKetentuan-Mobile/Hero.png"
      srcset="
        ../../assets/SyaratKetentuan-Mobile/Hero@2x.png 2x,
        ../../assets/SyaratKetentuan-Mobile/Hero@3x.png 3x
      "
      class="Hero"
    />
  <pertama-mobile/>
  <kedua-mobile/>
  </v-layout>
</template>
<script>
import KeduaMobile from '../../components/SyaratKetentuan/keduaMobile.vue';
import PertamaMobile from '../../components/SyaratKetentuan/pertamaMobile.vue';

export default {
  components: {PertamaMobile, KeduaMobile },

};
</script>
<style scoped>
.Hero {
  width: 100%;
  margin: 0 0 50px;
  object-fit: contain;
}
/* .Hero {
  width: 360px;
  height: 134px;
  margin: 0 0 50px;
  padding: 0 0 16px;
  object-fit: contain;
} */
.Hero-Text {
  /* width: 328px; */
  height: 30px;
  margin: 90px auto;
  font-family: Sora;
  font-size: 24px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.25;
  letter-spacing: -0.48px;
  text-align: center;
  color: #252525;
  position: absolute;
}
</style>
